import { styled } from "styled-components";
import { useAlertStore } from "../../store/alertStore";
import { theme } from "../../theme";
import { useEffect, useState } from "react";
import { ColorType } from "../../store/alertStore";

export const Alert = () => {
  const { message, color, show, hideAlert } = useAlertStore();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (show) {
      setVisible(true);

      const fadeTimeout = setTimeout(() => {
        setVisible(false);
      }, 2500);

      const hideTimeout = setTimeout(() => {
        hideAlert();
      }, 3000);

      return () => {
        clearTimeout(fadeTimeout);
        clearTimeout(hideTimeout);
      };
    }
  }, [show, hideAlert]);

  if (!show && !visible) return null;

  return (
    <AlertBox $color={color} $visible={visible}>
      {message}
    </AlertBox>
  );
};

const AlertBox = styled.div<{ $color: ColorType; $visible: boolean }>`
  color: ${({ $color }) => theme.color[$color]};
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  word-break: keep-all;
  background-color: #fff;
  max-width: 80%;
  min-width: 300px;
  padding: 20px;
  border: 4px solid ${({ $color }) => theme.color[$color]};
  border-radius: 15px;
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  animation: ${({ $visible }) =>
    $visible ? "fade-in 0.01s ease-in-out" : "fade-out 0.5s ease-in-out"};

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fade-out {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;
